import { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import api from "../api.js";

const SubmitIdeaPage = () => {
  const [modalOpen, setModalOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null);
  const [fields, setFields] = useState([]);
  const [relatedField, setRelatedField] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    api
      .get("/field/myfields/", {
        headers: {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
      })
      .then((res) => setFields(res.data));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("related_field", relatedField);
    if (file) formData.append("file", file);
  
    try {
      await api.post("/idea/create/", formData, {
        headers: {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
          "Content-Type": "multipart/form-data",
        },
      });
      setModalOpen(false);
      setSuccessModal(true);
      setTimeout(() => {
        navigate("/dashboard/ideas");
      }, 2000);
    } catch (err) {
      alert("ثبت ایده ناموفق بود!");
    } finally {
      setLoading(false);
    }
  };
  


  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100 px-4" dir="rtl">
      
        {modalOpen && (
          <div
            className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-xl space-y-6"
          >

            <form onSubmit={handleSubmit} className="space-y-5 text-right">
              <div>
                <label className="block mb-1 text-sm font-medium text-gray-700">عنوان</label>
                <input
                  type="text"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  required
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label className="block mb-1 text-sm font-medium text-gray-700">توضیحات</label>
                <textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  rows="4"
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                ></textarea>
              </div>

              <div>
                <label className="block mb-1 text-sm font-medium text-gray-700">حوزه مرتبط</label>
                <select
                  value={relatedField}
                  onChange={(e) => setRelatedField(e.target.value)}
                  required
                  className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
                >
                  <option value="">انتخاب کنید</option>
                  {fields.map((field) => (
                    <option key={field.id} value={field.id}>
                      {field.title}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="block mb-1 text-sm font-medium text-gray-700">فایل پیوست (اختیاری)</label>
                <input
                  type="file"
                  onChange={(e) => setFile(e.target.files[0])}
                  className="w-full text-sm text-gray-600"
                />
              </div>

              <div className="flex justify-between items-center pt-4">
                {/* <button
                  type="button"
                  onClick={() => setModalOpen(true)}
                  className="text-red-500 hover:text-red-700 font-medium"
                >
                  انصراف
                </button> */}
                <button
                  type="submit"
                  className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-2 rounded-lg"
                >
                  ثبت 
                </button>
              </div>
            </form>
          </div>
        )}

      {/* Success Modal */}
        {successModal && (
          <div
            className="absolute top-1/2 right-1/2 translate-x-1/2 -translate-y-1/2 bg-green-100 border border-green-400 text-green-800 px-6 py-4 rounded-xl shadow-lg text-lg font-medium"
          
          >
            ایده با موفقیت ثبت شد! در حال انتقال...
          </div>
        )}
    </div>
  );
};

export default SubmitIdeaPage;
